module.exports = __webpack_public_path__ + "static/media/default-template-small.4b914094.jpg";